<template>
    <b-modal
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :title="titulo"
        centered
        size="lg"
        id="modal-transferir"
        @hidden="cancelar"
    >
        <load
            v-if="loadingTransferencia"
            mode="table"
            message="Transferindo pessoa(s)"
        />
        <div v-else>
            <FamiliaExistente
                :pessoas="familiares"
                :selecteds="selectedItens"
                v-if="showSelecionarFamilia"
                @selecionada="SetFamiliaExistente"
                @vazio="familiaSelected = ''"
            />

            <FamiliaNova
                :pessoas="familiares"
                :selecteds="selectedItens"
                :endereco="endereco"
                :pessoas-selects="selectedItens"
                v-if="showNovaFamilia"
                @cancelar="cancelar"
                @store="transferir"
                @responsavel="SetResponsavel"
                @selecionada="SetFamiliaExistente"
            />

            <div v-if="showSelectUsuarios" class="row">
                <div class="col-md-12">
                    <table
                        v-if="familiares.length > 0"
                        class="b-table table table-striped b-table-stacked-md"
                    >
                        <thead>
                            <tr>
                                <th></th>
                                <th>Nome Completo</th>
                                <th>Posição Familiar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="familiar in familiares"
                                :key="familiar.id"
                            >
                                <td>
                                    <form-toggle
                                        @input="setSelected(familiar)"
                                    />
                                </td>
                                <td>
                                    <strong>{{
                                        familiar.nome_completo
                                    }}</strong>
                                    <br />
                                    <span v-if="familiar.documento">
                                        <span v-if="familiar.documento.nis"
                                            >NIS:
                                            {{ familiar.documento.nis }}</span
                                        >
                                        <span v-else>
                                            <b-link
                                                href="#"
                                                v-b-tooltip.hover
                                                title="Não sabe o número do NIS ou não foi inserido no cadastro!"
                                            >
                                                NIS:
                                                <b-icon
                                                    icon="exclamation-triangle-fill"
                                                    variant="warning"
                                                    animation="fade"
                                                ></b-icon>
                                            </b-link>
                                        </span>
                                    </span>
                                    <br />
                                    Sexo:
                                    <span v-if="familiar.sexo == 1">
                                        MASCULINO
                                    </span>
                                    <span v-if="familiar.sexo == 2">
                                        FEMININO
                                    </span>
                                    <span v-else> INTERSEXO </span>
                                    <br />
                                    Idade: {{ familiar.idade }} ano(s)
                                </td>
                                <td>
                                    <span
                                        v-for="posicao in familia.configs
                                            .posicao_familiar"
                                        :key="posicao.key"
                                    >
                                        <span
                                            v-if="
                                                posicao.key ==
                                                    familiar.posicao_familiar
                                            "
                                        >
                                            {{ posicao.value }}
                                        </span>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-if="isResponsavelSelected && familiaresOrganizar.length > 0">
                <div class="alert alert-warning p-2">
                    <i class="mdi mdi-alert mdi-24px"></i>
                    você está preste a transferir o responsável desta família,
                    então antes de continuar será necessário escolher um novo
                    responsável.
                </div>
                <h3>Selecione o novo Responsável</h3>
                <SetNovoResponsavel
                    :familiares="familiaresOrganizar"
                    @selected="SetResponsavel"
                />
            </div>
            <div class="row">
                <div class="col-12 d-flex justify-content-end">
                    <button
                        v-if="selectedId.length > 0 && showConcluir == false"
                        class="btn btn-primary"
                        @click="
                            showConcluir = true;
                            showSelecionarFamilia = true;
                            showSelectUsuarios = false;
                            titulo =
                                'Transferir pessoa(s) para Familia Existente';
                        "
                    >
                        <i class="mdi mdi-account-multiple-check"></i>
                        Transferir para Familia Existente
                    </button>
                    <button
                        v-if="selectedId.length > 0 && showConcluir == false"
                        class="btn btn-primary"
                        @click="
                            showNovaFamilia = true;
                            showConcluir = true;
                            showSelectUsuarios = false;
                            titulo = 'Transferir pessoa(s) para nova Familia';
                        "
                    >
                        <i class="mdi mdi-account-multiple-plus"></i>
                        Transferir para Nova Familia
                    </button>
                    <button
                        v-if="
                            showSelecionarFamilia == true &&
                                familiaSelected != ''
                        "
                        class="btn btn-success"
                        @click="transferir"
                    >
                        <i class="fas fa-share"></i> Concluir Transferência
                    </button>
                    <button
                        v-if="showNovaFamilia == false"
                        class="btn btn-danger mr-0"
                        @click="cancelar"
                    >
                        <i class="mdi mdi-close"></i> Cancelar
                    </button>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
import FamiliaNova from "./Transferir/FamiliaNova";
import FamiliaExistente from "./Transferir/FamiliaExistente";
import SetNovoResponsavel from "./Remanejar/SetNovoResponsavel";

export default {
    components: { FamiliaExistente, FamiliaNova, SetNovoResponsavel },
    props: ["familia", "pessoa"],

    data() {
        return {
            titulo: "Selecione a(s) pessoa(s) para Transferir",
            familiares: [],
            familiaresOrganizar: [],
            selectedId: [],
            selectedItens: [],
            endereco: {
                situacao_rua: false,
                complemento_endereco: "",
                numero_endereco: "",
                localidade: { nome_localidade: null, id: null },
                logradouro: { nome_logradouro: null, id: null }
            },
            familiaSelected: "",
            novo_responsavel: "",
            isResponsavelSelected: false,
            showConcluir: false,
            showSelectUsuarios: true,
            showSelecionarFamilia: false,
            showNovaFamilia: false,
            loadingTransferencia: false
        };
    },
    watch: {
        familia() {
            this.getFamiliares();
        }
    },
    mounted() {
        this.getFamiliares();
    },
    computed: {},
    methods: {
        estadoTransferivel(estado) {
            if (
                estado === null ||
                estado === undefined ||
                String(estado).trim() === ""
            ) {
                return true;
            }

            return [0, 1, 3].indexOf(Number(estado)) !== -1;
        },
        getFamiliares() {
            this.familiares = this.familia.familiares.filter(
                familiar =>
                this.estadoTransferivel(
                    familiar.estado_cadastral_cadunico
                )
            );
        },
        SetFamiliaExistente(familia) {
            this.familiaSelected = familia;
            this.organizarMembros();
        },
        SetResponsavel(usuario) {
            this.novo_responsavel = usuario;
        },
        organizarMembros() {
            this.selectedItens.forEach(ev => {
                if (ev.posicao_familiar == 1) {
                    this.isResponsavelSelected = true;
                }
            });

            this.familiaresOrganizar =
                this.familia.familiares.filter(
                    familiar =>
                    this.estadoTransferivel(
                        familiar.estado_cadastral_cadunico
                    )
                );

            this.familiaresOrganizar = this.familiaresOrganizar.filter(
                ev => this.selectedId.indexOf(ev.id) === -1
            );
        },
        transferir() {
            this.loadingTransferencia = true;
            axios
                .post("api/dashboard/familias/transferir", {
                    familia_id: this.familiaSelected.id,
                    usuarios: this.selectedId,
                    nova_familia: this.showNovaFamilia,
                    novo_responsavel: this.novo_responsavel,
                    endereco: this.endereco
                })
                .then(response => {
                    this.loadingTransferencia = false;
                    this.cancelar();
                    this.$snack.success({
                        button: false,
                        text: "Transferência realizada com sucessos."
                    });
                    this.$emit("atualizar");
                });
        },
        setSelected(familiar) {
            let key = this.selectedId.indexOf(familiar.id);

            if (key > -1) {
                this.selectedId.splice(key, 1);
                this.selectedItens.splice(key, 1);
            } else {
                this.selectedId.push(familiar.id);
                this.selectedItens.push(familiar);
            }
        },
        cancelar() {
            //Reset data
            Object.assign(this.$data, this.$options.data.call(this));
            this.getFamiliares();
            this.$bvModal.hide("modal-transferir");
        }
    }
};
</script>
